module.exports = __webpack_public_path__ + "static/media/user1.4cd6ed6e.jpg";